module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon-默认图标-论坛.3b1a4.png";